angular.module('bizmetryApp')
    .controller('EditResourceDialogController', function (
        $scope, $q, $mdDialog, $mdToast, $timeout,
        ResourceService, TemplateInstanceService, DatasourceService, dialogService,
        resource, profile, environments
    ) {
        var vm = this;

        // ===== LOADING STATE =====
        vm.loadingResource = true;
        vm.loadingResourceTypes = true;
        vm.loadingDatasources = true;

        // ===== RESOURCE TYPES =====
        vm.resourceTypes = [];
        vm.templateInstancesByEnvId = {};

        // ===== DATASOURCES STATE =====
        vm.datasources = [];
        vm.datasourcesById = {};

        // ===== ENVIRONMENTS (built from param — no resource data needed yet) =====
        vm.environments = (environments || []).map(function (refEnv) {
            return {
                id: refEnv.id,
                name: refEnv.name,
                envType: refEnv.envType || null,
                envTypeId: refEnv.envTypeId || null,
                agentId: refEnv.agent_id || null,
                agentStatus: refEnv.agent_status || null,
                agentLastSyncupTs: refEnv.agent_last_syncup_ts || null,
                templateInstanceId: refEnv.templateInstanceId || null,
                templateInstanceStatus: refEnv.templateInstanceStatus || null,
                templateInstanceVersion: refEnv.templateInstanceVersion || null,
                description: refEnv.description || '',
                enabled: false   // will be overwritten after resource fetch
            };
        });

        // ===== TRACKING =====
        vm.model = {};
        vm.selectedEnvs = {};
        vm.envPkValues = {};
        vm.primaryKeyAttributesCache = {};
        vm.fieldValidationErrors = {};
        vm.allSelected = false;
        vm.isSaving = false;

        // =====================================================================
        // HELPERS DE RESOURCE TYPE
        // Definidos ANTES de initializeEnvironments() / updateAllSelectedState()
        // =====================================================================

        vm.getEnvNameById = function (envId) {
            var env = vm.environments.find(function (e) { return e.id === envId; });
            return env ? env.name : envId;
        };

        vm.isEnvDisabledForResourceType = function (envId) {
            if (!vm.model.resourceType || !vm.model.resourceType.id) { return false; }
            if (vm.model.resourceType.isCommon) { return false; }
            return (vm.model.resourceType.envIds || []).indexOf(envId) === -1;
        };

        // =====================================================================
        // INIT — fetch resource fresco del backend primero
        // =====================================================================

        loadDatasources();

        ResourceService.getResourceById(profile.id, resource.id)
            .then(function (response) {
                var freshResource = response.data;

                // Inicializar modelo con datos frescos
                vm.model = angular.copy(freshResource);

                // Actualizar enabled en vm.environments con datos frescos
                vm.environments.forEach(function (env) {
                    var resourceEnv = (freshResource.environments || []).find(function (re) {
                        return re.id === env.id;
                    });
                    env.enabled = resourceEnv ? resourceEnv.enabled : false;
                });

                initializeEnvironments(freshResource);
                vm.originalSelectedEnvs = angular.copy(vm.selectedEnvs);
                vm.originalEnvPkValues = angular.copy(vm.envPkValues);
                updateAllSelectedState();

                vm.loadingResource = false;

                // Cargar templates después de tener el resource fresco
                loadTemplateInstancesAndBuildResourceTypes(freshResource);
            })
            .catch(function (error) {
                console.error('❌ Error fetching resource:', error);
                vm.loadingResource = false;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Error loading resource data. Please try again.')
                        .position('top right')
                        .hideDelay(4000)
                );
                $mdDialog.cancel('load_error');
            });

        // =====================================================================
        // TEMPLATE INSTANCES & RESOURCE TYPES
        // =====================================================================
        function loadTemplateInstancesAndBuildResourceTypes(freshResource) {
            vm.loadingResourceTypes = true;

            var eligibleEnvs = vm.environments.filter(function (env) {
                return (env.agentStatus === 'ONLINE' || env.agentStatus === 'STALLED') &&
                    env.templateInstanceStatus === 'PUBLISHED' &&
                    env.templateInstanceId;
            });

            if (eligibleEnvs.length === 0) {
                console.warn('[EditResourceDialog] No eligible environments (ONLINE + PUBLISHED) found');
                vm.loadingResourceTypes = false;
                vm.resourceTypes = [];
                isRestoringFromBackend = false;
                return;
            }

            var uniqueTemplateInstanceIds = [];
            var seen = {};
            eligibleEnvs.forEach(function (env) {
                if (!seen[env.templateInstanceId]) {
                    seen[env.templateInstanceId] = true;
                    uniqueTemplateInstanceIds.push(env.templateInstanceId);
                }
            });

            var fetchPromises = uniqueTemplateInstanceIds.map(function (templateInstanceId) {
                return TemplateInstanceService.getTemplateInstanceById(templateInstanceId)
                    .then(function (response) { return response.data; })
                    .catch(function (error) {
                        console.error('Error loading template instance:', templateInstanceId, error);
                        return null;
                    });
            });

            $q.all(fetchPromises).then(function (templateInstances) {
                var validTemplates = templateInstances.filter(function (t) { return t != null; });

                if (validTemplates.length === 0) {
                    console.warn('[EditResourceDialog] Could not load any template instances');
                    vm.loadingResourceTypes = false;
                    isRestoringFromBackend = false;
                    $mdToast.show($mdToast.simple()
                        .textContent('Could not load resource types from templates')
                        .position('top right').hideDelay(4000));
                    return;
                }

                var templateById = {};
                validTemplates.forEach(function (ti) { templateById[ti.id] = ti; });

                eligibleEnvs.forEach(function (env) {
                    var ti = templateById[env.templateInstanceId];
                    if (ti) { vm.templateInstancesByEnvId[env.id] = ti; }
                });

                vm.resourceTypes = buildAllResourceTypes(validTemplates, eligibleEnvs);

                console.log('✅ Resource types loaded:', vm.resourceTypes.length,
                    '(common:', vm.resourceTypes.filter(function (rt) { return rt.isCommon; }).length,
                    ', specific:', vm.resourceTypes.filter(function (rt) { return !rt.isCommon; }).length, ')');

                // Restaurar el resource type del resource fresco
                if (freshResource.resourceTypeId) {
                    vm.model.resourceType = vm.resourceTypes.find(function (t) {
                        return t.id === freshResource.resourceTypeId;
                    }) || null;

                    if (!vm.model.resourceType) {
                        console.warn('[EditResourceDialog] Resource type not found in list:', freshResource.resourceTypeId);
                    }
                }

                vm.primaryKeyAttributesCache = {};
                vm.loadingResourceTypes = false;

                // ✅ Diferir hasta DESPUÉS del digest actual para que el watch
                // que detecta vm.model.resourceType = ... todavía vea el flag en true
                $timeout(function () {
                    isRestoringFromBackend = false;
                }, 0);


            });
        }

        function buildAllResourceTypes(templateInstances, eligibleEnvs) {
            if (!templateInstances || templateInstances.length === 0) { return []; }

            var templateToEnvIds = {};
            eligibleEnvs.forEach(function (env) {
                if (!templateToEnvIds[env.templateInstanceId]) {
                    templateToEnvIds[env.templateInstanceId] = [];
                }
                templateToEnvIds[env.templateInstanceId].push(env.id);
            });

            var sorted = templateInstances.slice().sort(function (a, b) {
                var vA = a.version || a.templateVersion || '0';
                var vB = b.version || b.templateVersion || '0';
                return vB.localeCompare(vA, undefined, { numeric: true });
            });

            var rtMap = {};
            sorted.forEach(function (ti) {
                var envIds = templateToEnvIds[ti.id] || [];
                var rts = extractResourceTypes(ti);
                rts.forEach(function (rt) {
                    if (!rtMap[rt.id]) {
                        rtMap[rt.id] = angular.extend({}, rt, { envIds: [] });
                    }
                    envIds.forEach(function (envId) {
                        if (rtMap[rt.id].envIds.indexOf(envId) === -1) {
                            rtMap[rt.id].envIds.push(envId);
                        }
                    });
                });
            });

            var allEligibleEnvIds = eligibleEnvs.map(function (e) { return e.id; });

            var result = [];
            Object.keys(rtMap).forEach(function (id) {
                var rt = rtMap[id];
                var isCommon = allEligibleEnvIds.every(function (envId) {
                    return rt.envIds.indexOf(envId) !== -1;
                });
                result.push(angular.extend({}, rt, { isCommon: isCommon }));
            });

            return result.sort(function (a, b) {
                if (a.isCommon && !b.isCommon) { return -1; }
                if (!a.isCommon && b.isCommon) { return 1; }
                return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
            });
        }

        function extractResourceTypes(templateInstance) {
            if (!templateInstance || !templateInstance.templateConfig || !templateInstance.templateConfig.resource_types) { return []; }
            return templateInstance.templateConfig.resource_types
                .filter(function (rt) { return rt.enabled !== false; });
        }

        function getTemplateInstanceForResourceType(resourceTypeId) {
            var envIds = Object.keys(vm.templateInstancesByEnvId);
            for (var i = 0; i < envIds.length; i++) {
                var ti = vm.templateInstancesByEnvId[envIds[i]];
                if (ti && ti.templateConfig && ti.templateConfig.resource_types) {
                    var found = ti.templateConfig.resource_types.find(function (rt) { return rt.id === resourceTypeId; });
                    if (found) { return ti; }
                }
            }
            return envIds.length > 0 ? vm.templateInstancesByEnvId[envIds[0]] : null;
        }

        // =====================================================================
        // DATASOURCES
        // =====================================================================

        function loadDatasources() {
            vm.loadingDatasources = true;
            DatasourceService.getDatasources(profile.id)
                .then(function (datasources) {
                    vm.datasources = datasources || [];
                    vm.datasourcesById = {};
                    vm.datasources.forEach(function (ds) { vm.datasourcesById[ds.id] = ds; });
                })
                .catch(function (error) {
                    console.error('Error loading datasources:', error);
                    $mdToast.show($mdToast.simple()
                        .textContent('Warning: Could not load datasource status')
                        .position('top right').hideDelay(3000));
                })
                .finally(function () { vm.loadingDatasources = false; });
        }

        vm.getDatasourceForMapping = function (envMapping) {
            if (!envMapping || !envMapping.datasource_id) { return null; }
            return vm.datasourcesById[envMapping.datasource_id] || null;
        };

        vm.isDatasourceOnline = function (envId) {
            var envMapping = vm.getEnvMapping(envId);
            if (!envMapping) { return false; }
            var datasource = vm.getDatasourceForMapping(envMapping);
            return datasource ? datasource.isOnline === true : false;
        };

        vm.getDatasourceStatusText = function (envId) {
            if (vm.loadingDatasources) { return 'Loading...'; }
            var envMapping = vm.getEnvMapping(envId);
            if (!envMapping) { return 'No mapping'; }
            var datasource = vm.getDatasourceForMapping(envMapping);
            if (!datasource) { return 'Not found'; }
            return datasource.isOnline ? 'Online' : 'Offline';
        };

        // =====================================================================
        // ENVIRONMENTS INITIALIZATION
        // =====================================================================

        function initializeEnvironments(freshResource) {
            (freshResource.environments || []).forEach(function (env) {
                if (env.enabled) {
                    vm.selectedEnvs[env.id] = true;
                    vm.envPkValues[env.id] = {};
                    if (env.externalKeyMappings && Array.isArray(env.externalKeyMappings)) {
                        env.externalKeyMappings.forEach(function (mapping) {
                            vm.envPkValues[env.id][mapping.attributeId] = mapping.attributeValue;
                        });
                    }
                }
            });
            vm.environments.forEach(function (env) {
                if (!vm.envPkValues[env.id]) { vm.envPkValues[env.id] = {}; }
            });
        }

        // =====================================================================
        // PRIMARY KEY ATTRIBUTES
        // =====================================================================

        vm.getPrimaryKeyAttributes = function (resourceTypeId, envId) {
            if (!resourceTypeId) { return []; }

            var cacheKey = resourceTypeId + (envId ? '_' + envId : '');
            if (vm.primaryKeyAttributesCache[cacheKey]) { return vm.primaryKeyAttributesCache[cacheKey]; }

            var templateInstance = envId
                ? (vm.templateInstancesByEnvId[envId] || getTemplateInstanceForResourceType(resourceTypeId))
                : getTemplateInstanceForResourceType(resourceTypeId);

            if (!templateInstance) { return []; }

            var pkAttributes = [];
            try {
                var templateJson = templateInstance.templateConfig;
                if (templateJson && templateJson.attribute_types && Array.isArray(templateJson.attribute_types)) {
                    pkAttributes = templateJson.attribute_types
                        .filter(function (attr) { return attr.resource_id === resourceTypeId && attr.isPrimaryKey === true; })
                        .map(function (attr) {
                            return {
                                id: attr.id,
                                name: attr.name,
                                column_name: attr.column_metadata_name,
                                column_metadata_name: attr.column_metadata_name,
                                description: attr.description || '',
                                type: attr.scalar_attribute_type || 'STRING',
                                lowerBound: attr.lower_bound,
                                upperBound: attr.upper_bound
                            };
                        });
                }
                vm.primaryKeyAttributesCache[cacheKey] = pkAttributes;
            } catch (error) {
                console.error('Error getting primary key attributes:', error);
            }
            return pkAttributes;
        };

        vm.initializePkValuesForEnv = function (envId) {
            if (!vm.model.resourceType || !vm.model.resourceType.id) { return; }
            if (!vm.envPkValues[envId]) { vm.envPkValues[envId] = {}; }
            var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceType.id, envId);
            pkAttrs.forEach(function (attr) {
                if (vm.envPkValues[envId][attr.id] === undefined) { vm.envPkValues[envId][attr.id] = ''; }
            });
        };

        vm.clearAllPkValues = function () {
            vm.envPkValues = {};
            vm.primaryKeyAttributesCache = {};
            Object.keys(vm.selectedEnvs).forEach(function (envId) {
                if (vm.selectedEnvs[envId]) { vm.initializePkValuesForEnv(envId); }
            });
        };

        vm.areAllPkFieldsFilled = function (envId) {
            if (!vm.model.resourceType || !vm.model.resourceType.id) { return false; }
            if (!vm.envPkValues[envId]) { return false; }
            var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceType.id, envId);
            if (pkAttrs.length === 0) { return true; }
            return pkAttrs.every(function (attr) {
                var value = vm.envPkValues[envId][attr.id];
                return value && value.trim() !== '';
            });
        };

        vm.getFilledPkCount = function (envId) {
            if (!vm.envPkValues[envId] || !vm.model.resourceType || !vm.model.resourceType.id) { return 0; }
            var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceType.id, envId);
            return pkAttrs.filter(function (attr) {
                var value = vm.envPkValues[envId][attr.id];
                return value && value.trim() !== '';
            }).length;
        };

        vm.buildExternalKeyMappings = function (envId) {
            if (!vm.envPkValues[envId] || !vm.model.resourceType || !vm.model.resourceType.id) { return []; }
            var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceType.id, envId);
            if (!pkAttrs || pkAttrs.length === 0) { return []; }
            var mappings = [];
            pkAttrs.forEach(function (attr) {
                var value = vm.envPkValues[envId][attr.id];
                if (value && value.trim() !== '') {
                    mappings.push({ attributeId: attr.id, attributeName: attr.name, attributeValue: value.trim() });
                }
            });
            return mappings;
        };

        // ===== WATCH resourceType =====
        var isInitialLoad = true;
        var isRestoringFromBackend = true;

        $scope.$watch('vm.model.resourceType', function (newType, oldType) {
            if (isRestoringFromBackend) {
                // Durante la restauración: solo limpiar envs incompatibles,
                // preservar la selección cargada del backend
                if (newType) {
                    vm.environments.forEach(function (env) {
                        if (vm.isEnvDisabledForResourceType(env.id)) {
                            vm.selectedEnvs[env.id] = false;
                            delete vm.envPkValues[env.id];
                        }
                    });
                    updateAllSelectedState();
                }
                return;
            }
            // Cambio manual del usuario: blanquear todo
            vm.selectedEnvs = {};
            vm.envPkValues = {};
            vm.primaryKeyAttributesCache = {};
            vm.allSelected = false;
            updateAllSelectedState();
        });

        // =====================================================================
        // ENVIRONMENTS TOGGLE
        // =====================================================================

        function updateAllSelectedState() {
            var enabledEnvs = vm.environments.filter(function (env) {
                return !vm.isEnvDisabledForResourceType(env.id);
            });
            var totalEnvs = enabledEnvs.length;
            var selectedCount = enabledEnvs.filter(function (env) {
                return vm.selectedEnvs[env.id] === true;
            }).length;
            vm.allSelected = (selectedCount === totalEnvs && totalEnvs > 0);
        }

        vm.isEnvSelected = function (envId) { return vm.selectedEnvs[envId] === true; };

        vm.hasSelectedEnvs = function () {
            return Object.keys(vm.selectedEnvs).some(function (key) { return vm.selectedEnvs[key] === true; });
        };

        vm.onEnvToggle = function (env) {
            if (!vm.selectedEnvs[env.id]) {
                delete vm.envPkValues[env.id];
            } else {
                if (vm.model.resourceType && vm.model.resourceType.id) { vm.initializePkValuesForEnv(env.id); }
            }
            updateAllSelectedState();
        };

        vm.toggleSelectAll = function () {
            var newState = vm.allSelected;
            vm.environments.forEach(function (env) {
                if (vm.isEnvDisabledForResourceType(env.id)) { return; }
                vm.selectedEnvs[env.id] = newState;
                if (newState) {
                    if (vm.model.resourceType && vm.model.resourceType.id) { vm.initializePkValuesForEnv(env.id); }
                } else {
                    delete vm.envPkValues[env.id];
                }
            });
        };

        // =====================================================================
        // ENV MAPPINGS
        // =====================================================================

        vm.hasEnvMapping = function (envId) {
            if (!vm.model.resourceType || !vm.model.resourceType.id) { return false; }
            var templateInstance = vm.templateInstancesByEnvId[envId];
            if (!templateInstance || !templateInstance.templateConfig || !templateInstance.templateConfig.resource_types) { return false; }
            var resourceType = templateInstance.templateConfig.resource_types.find(function (rt) { return rt.id === vm.model.resourceType.id; });
            if (!resourceType || !resourceType.env_mappings) { return false; }
            return !!resourceType.env_mappings.find(function (m) { return m.env_id === envId && !m.markedForDeletion; });
        };

        vm.getEnvMapping = function (envId) {
            if (!vm.model.resourceType || !vm.model.resourceType.id) { return null; }
            var templateInstance = vm.templateInstancesByEnvId[envId];
            if (!templateInstance || !templateInstance.templateConfig || !templateInstance.templateConfig.resource_types) { return null; }
            var resourceType = templateInstance.templateConfig.resource_types.find(function (rt) { return rt.id === vm.model.resourceType.id; });
            if (!resourceType || !resourceType.env_mappings) { return null; }
            return resourceType.env_mappings.find(function (m) { return m.env_id === envId && !m.markedForDeletion; }) || null;
        };

        vm.isMasterEnv = function (envId) {
            if (vm.model && vm.model.environments) {
                var savedEnv = vm.model.environments.find(function (e) { return e.id === envId; });
                if (savedEnv) { return savedEnv.masterEnvironment === true; }
            }
            if (vm.model.resourceType && vm.model.resourceType.envMappings) {
                return vm.model.resourceType.envMappings.some(function (m) {
                    return m.env_id === envId && Boolean(m.is_master);
                });
            }
            return false;
        };

        // =====================================================================
        // FORM VALIDATION
        // =====================================================================

        vm.isFormValid = function () { return $scope.resourceForm && $scope.resourceForm.$valid; };

        vm.isLoading = function () { return vm.loadingResource || vm.loadingResourceTypes; };

        vm.canUpdateResource = function () {
            if (vm.isLoading()) { return false; }
            if (!vm.isFormValid()) { return false; }
            if (!vm.model.resourceType || !vm.model.resourceType.id) { return false; }
            if (!vm.isFormDirty()) { return false; }

            var selectedEnvIds = Object.keys(vm.selectedEnvs).filter(function (envId) {
                return vm.selectedEnvs[envId] === true;
            });

            if (selectedEnvIds.length > 0) {
                var pkAttrs = vm.getPrimaryKeyAttributes(vm.model.resourceType.id);

                // ✅ Env seleccionado pero sin PKs definidas → bloquear save
                if (!pkAttrs || pkAttrs.length === 0) { return false; }

                return selectedEnvIds.every(function (envId) {
                    return vm.areAllPkFieldsFilled(envId);
                });
            }

            return true;
        };

        vm.isFormDisabled = function () {
            return vm.isLoading() || !vm.model.resourceName || vm.model.resourceName.trim() === '' ||
                !vm.model.resourceType || vm.isSaving;
        };

        vm.isFormDirty = function () {
            if (!vm.model.resourceName) { return false; }
            var isNameDirty = vm.model.resourceName !== (vm.model._original && vm.model._original.resourceName);
            var isDescriptionDirty = (vm.model.resourceDescription || '') !== ((vm.model._original && vm.model._original.resourceDescription) || '');
            var isResourceTypeDirty = vm.model.resourceType && vm.model.resourceType.id !== (vm.model._original && vm.model._original.resourceTypeId);
            var currentSelectedEnvIds = Object.keys(vm.selectedEnvs).filter(function (k) { return vm.selectedEnvs[k]; }).sort();
            var originalSelectedEnvIds = Object.keys(vm.originalSelectedEnvs || {}).filter(function (k) { return vm.originalSelectedEnvs[k]; }).sort();
            var isEnvSelectionDirty = JSON.stringify(currentSelectedEnvIds) !== JSON.stringify(originalSelectedEnvIds);
            var isPkValuesDirty = JSON.stringify(vm.envPkValues) !== JSON.stringify(vm.originalEnvPkValues || {});
            return isNameDirty || isDescriptionDirty || isResourceTypeDirty || isEnvSelectionDirty || isPkValuesDirty;
        };

        // =====================================================================
        // PICK FROM DATABASE
        // =====================================================================

        vm.pickFromDatabase = function (env, $event) {
            if ($event) { $event.stopPropagation(); }
            var envMapping = vm.getEnvMapping(env.id);
            if (!envMapping) { dialogService.showErrorDialog('Configuration Error', 'No database mapping found for this environment.'); return; }
            if (!vm.isDatasourceOnline(env.id)) {
                var ds = vm.getDatasourceForMapping(envMapping);
                var dsName = ds ? ds.datasourceName : envMapping.datasource_name || 'Unknown';
                dialogService.showErrorDialog('Datasource Offline', 'The datasource "' + dsName + '" is currently offline.');
                return;
            }
            var pkAttributes = vm.getPrimaryKeyAttributes(vm.model.resourceType.id, env.id);
            if (!pkAttributes || pkAttributes.length === 0) { dialogService.showErrorDialog('Configuration Error', 'No primary key attributes defined for this resource type.'); return; }
            var resourceAttributes = getResourceAttributesForEnv(env.id, vm.model.resourceType.id);
            if (!resourceAttributes || resourceAttributes.length === 0) { dialogService.showErrorDialog('Configuration Error', 'No attributes found for this resource type.'); return; }

            var existingPKsPromise = ResourceService.getResourcePKs(profile.id, env.id, vm.model.resourceType.id)
                .then(function (response) { return response.data.pks || []; })
                .catch(function () { return []; });

            existingPKsPromise.then(function (existingPKs) {
                $mdDialog.show({
                    controller: 'DatabasePickerDialogController',
                    controllerAs: 'vm',
                    templateUrl: 'profile/tabs/resources/database-picker/database-picker-dialog.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    multiple: true,
                    locals: { envMapping: envMapping, pkAttributes: pkAttributes, environment: env, resourceAttributes: resourceAttributes, maxSelections: 1, existingPKs: existingPKs }
                }).then(function (selectedRecords) {
                    if (!selectedRecords || selectedRecords.length === 0) { return; }
                    var primaryKeys = selectedRecords[0].primaryKeys;
                    if (!vm.envPkValues[env.id]) { vm.initializePkValuesForEnv(env.id); }
                    if (vm.fieldValidationErrors[env.id]) { delete vm.fieldValidationErrors[env.id]; }
                    primaryKeys.forEach(function (pkMapping) { vm.envPkValues[env.id][pkMapping.attributeId] = pkMapping.attributeValue; });
                    $mdToast.show($mdToast.simple().textContent('Primary key values loaded from database').position('top right').hideDelay(2000));
                }).catch(function (error) {
                    if (error !== 'user_cancelled' && error !== 'cancel') { console.error('Error picking from database:', error); }
                });
            });
        };

        // =====================================================================
        // VIEW RECORD DETAILS
        // =====================================================================

        // Shows the record stored for this environment at import (Resource.sourceRecords): read from
        // resource-ms, no agent call, so it works with the datasource offline.
        vm.viewRecordDetails = function (env, $event) {
            if ($event) { $event.stopPropagation(); }
            if (!env) { return; }
            var pkAttributes = vm.getPrimaryKeyAttributes(vm.model.resourceType.id, env.id);
            if (!pkAttributes || pkAttributes.length === 0) { $mdToast.show($mdToast.simple().textContent('No primary key attributes found').position('top right').hideDelay(3000)); return; }
            var firstPkAttr = pkAttributes[0];
            var pkValue = vm.envPkValues[env.id][firstPkAttr.id];
            if (!pkValue || pkValue.trim() === '') { $mdToast.show($mdToast.simple().textContent('Primary key value is empty').position('top right').hideDelay(3000)); return; }
            var resourceAttributes = getResourceAttributesForEnv(env.id, vm.model.resourceType.id);
            if (!resourceAttributes || resourceAttributes.length === 0) { $mdToast.show($mdToast.simple().textContent('Failed to load resource attributes').position('top right').hideDelay(3000)); return; }

            $mdDialog.show({
                controller: 'ViewRecordDetailsDialogController',
                controllerAs: 'vm',
                templateUrl: 'profile/tabs/resources/view-record/view-record-details-dialog.html',
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true,
                multiple: true,
                locals: {
                    profile: profile, environment: env, resource: vm.model, resourceType: vm.model.resourceType,
                    pkAttribute: firstPkAttr, pkColumnName: firstPkAttr.column_metadata_name || firstPkAttr.name,
                    pkValue: pkValue, resourceAttributes: resourceAttributes
                }
            }).catch(function (error) {
                if (error !== 'user_cancelled' && error !== 'cancel') { console.error('Error opening record details dialog:', error); }
            });
        };

        // =====================================================================
        // HELPER: resource attributes por env
        // =====================================================================

        function getResourceAttributesForEnv(envId, resourceTypeId) {
            var templateInstance = vm.templateInstancesByEnvId[envId] || getTemplateInstanceForResourceType(resourceTypeId);
            if (!templateInstance) { return []; }
            var templateJson = templateInstance.templateConfig;
            if (!templateJson || !templateJson.attribute_types) { return []; }
            return templateJson.attribute_types
                .filter(function (attr) { return attr.resource_id === resourceTypeId; })
                .map(function (attr) {
                    return {
                        id: attr.id, name: attr.name,
                        column_metadata_name: attr.column_metadata_name,
                        description: attr.description || '',
                        scalar_attribute_type: attr.scalar_attribute_type || 'STRING',
                        isPrimaryKey: attr.isPrimaryKey || false,
                        isResourceNameField: attr.isResourceNameField || false,
                        isResourceDescriptionField: attr.isResourceDescriptionField || false,
                        isSensitive: attr.isSensitive || false,
                        lower_bound: attr.lower_bound, upper_bound: attr.upper_bound,
                        jsonSchema: attr.jsonSchema, jsonSample: attr.jsonSample,
                        resourceNameJsonPath: attr.resourceNameJsonPath,
                        resourceDescriptionJsonPath: attr.resourceDescriptionJsonPath
                    };
                });
        }

        // =====================================================================
        // FIELD VALIDATION ERRORS
        // =====================================================================

        vm.clearValidationError = function (envId, attrId) {
            if (vm.fieldValidationErrors[envId] && vm.fieldValidationErrors[envId][attrId]) { delete vm.fieldValidationErrors[envId][attrId]; }
        };
        vm.clearAllValidationErrors = function () { vm.fieldValidationErrors = {}; };
        vm.hasValidationError = function (envId, attrId) { return !!(vm.fieldValidationErrors[envId] && vm.fieldValidationErrors[envId][attrId]); };
        vm.getValidationError = function (envId, attrId) { return vm.fieldValidationErrors[envId] ? vm.fieldValidationErrors[envId][attrId] : null; };

        // =====================================================================
        // UPDATE RESOURCE
        // =====================================================================

        vm.updateResource = function () {
            if (vm.isSaving) { return; }
            vm.clearAllValidationErrors();

            if (!vm.canUpdateResource()) {
                $mdToast.show($mdToast.simple().textContent('Please complete all required fields').position('top right').hideDelay(3000));
                return;
            }

            vm.isSaving = true;

            var selectedEnvIds = Object.keys(vm.selectedEnvs).filter(function (envId) { return vm.selectedEnvs[envId] === true; });
            var needsValidation = checkIfAnyEnvResourceImported(selectedEnvIds) && selectedEnvIds.length > 0;

            if (needsValidation) {
                validateRecordsInDatabase(selectedEnvIds)
                    .then(function () { proceedWithUpdate(); })
                    .catch(function (error) { vm.isSaving = false; showValidationToast(error); });
            } else {
                proceedWithUpdate();
            }

            function checkIfAnyEnvResourceImported(envIds) {
                return envIds.some(function (envId) {
                    var templateInstance = vm.templateInstancesByEnvId[envId];
                    if (!templateInstance || !templateInstance.templateConfig || !templateInstance.templateConfig.resource_types) { return false; }
                    var rtConfig = templateInstance.templateConfig.resource_types.find(function (rt) { return rt.id === vm.model.resourceType.id; });
                    return rtConfig ? rtConfig.is_resource_imported === true : false;
                });
            }

            function validateRecordsInDatabase(envIds) {
                return $q.all(envIds.map(function (envId) { return validateSingleEnvironment(envId); }))
                    .then(function (results) {
                        var notFound = results.filter(function (r) { return !r.exists && !r.skipped; });
                        if (notFound.length > 0) {
                            notFound.forEach(function (result) {
                                if (!vm.fieldValidationErrors[result.envId]) { vm.fieldValidationErrors[result.envId] = {}; }
                                result.pkValues.forEach(function (pkValue) {
                                    vm.fieldValidationErrors[result.envId][pkValue.attributeId] = 'Record not found in database';
                                });
                            });
                            $scope.$applyAsync(function () { scrollToFirstError(); });
                            return $q.reject({ type: 'RECORDS_NOT_FOUND', notFoundEnvs: notFound });
                        }
                    });
            }

            function validateSingleEnvironment(envId) {
                var env = vm.environments.find(function (e) { return e.id === envId; });
                if (!env) { return $q.resolve({ envId: envId, envName: 'Unknown', exists: true, skipped: true }); }
                var envMapping = vm.getEnvMapping(envId);
                if (!envMapping) { return $q.resolve({ envId: envId, envName: env.name, exists: true, skipped: true, reason: 'No mapping' }); }
                if (!vm.isDatasourceOnline(envId)) { return $q.resolve({ envId: envId, envName: env.name, exists: true, skipped: true, reason: 'Datasource offline' }); }
                var pkAttributes = vm.getPrimaryKeyAttributes(vm.model.resourceType.id, envId);
                if (!pkAttributes || pkAttributes.length === 0) { return $q.resolve({ envId: envId, envName: env.name, exists: true, skipped: true, reason: 'No PK attributes' }); }
                var pkValues = pkAttributes.map(function (attr) {
                    return { attributeId: attr.id, attributeName: attr.name, attributeValue: vm.envPkValues[envId][attr.id], columnName: attr.column_metadata_name || attr.name };
                });
                var firstPk = pkValues[0];
                return DatasourceService.getTableData(
                    envMapping.datasource_id, envMapping.schema_name, envMapping.table_name,
                    [{ sequence: 1, columnName: firstPk.columnName }],
                    { idColumnName: firstPk.columnName, idValue: firstPk.attributeValue, limit: 1 }
                ).then(function (response) {
                    return { envId: envId, envName: env.name, exists: !!(response && response.rows && response.rows.length > 0), pkValues: pkValues };
                }).catch(function (error) {
                    return { envId: envId, envName: env.name, exists: false, pkValues: pkValues, error: error.data && error.data.message ? error.data.message : 'Validation failed' };
                });
            }

            function showValidationToast(error) {
                var message = (error.type === 'RECORDS_NOT_FOUND' && error.notFoundEnvs)
                    ? (error.notFoundEnvs.length === 1
                        ? 'Record not found in database. Please verify the primary key values.'
                        : error.notFoundEnvs.length + ' records not found in database. Please verify the primary key values.')
                    : 'Failed to validate records in database';
                $mdToast.show($mdToast.simple().textContent(message).position('top right').hideDelay(5000));
            }

            function scrollToFirstError() {
                setTimeout(function () {
                    var firstErrorInput = document.querySelector('.pk-input-validation-error input');
                    if (firstErrorInput) { firstErrorInput.scrollIntoView({ behavior: 'smooth', block: 'center' }); firstErrorInput.focus(); }
                }, 100);
            }

            function proceedWithUpdate() {
                var selectedEnvironments = vm.environments.map(function (env) {
                    return {
                        id: env.id,
                        name: env.name,
                        enabled: !!vm.selectedEnvs[env.id],
                        externalKeyMappings: vm.buildExternalKeyMappings(env.id)
                    };
                });

                var payload = {
                    resourceName: vm.model.resourceName.trim(),
                    resourceDescription: vm.model.resourceDescription ? vm.model.resourceDescription.trim() : null,
                    enabled: vm.model.enabled,
                    resourceType: vm.model.resourceType,
                    requiresAttention: false,
                    environments: selectedEnvironments
                };

                ResourceService.patchResource(profile.id, vm.model.id, payload)
                    .then(function (response) {
                        $mdToast.show($mdToast.simple().textContent('Resource updated successfully!').position('top right').hideDelay(3000));
                        $mdDialog.hide(response.data || true);
                    })
                    .catch(function (error) {
                        var errorMessage = 'Error updating resource: ';
                        if (error.data && error.data.message) { errorMessage += error.data.message; }
                        else if (error.statusText) { errorMessage += error.statusText; }
                        else { errorMessage += 'Unknown error'; }
                        dialogService.showErrorDialog('Update Failed', errorMessage);
                    })
                    .finally(function () { vm.isSaving = false; });
            }
        };

        vm.cancel = function () { $mdDialog.cancel('user_cancelled'); };

    });